import React, { useEffect, useState } from "react";
import CustomHookForRuralDetails from "../ruralDetailsCount/CustomHookForRuralDetails";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../ui/CustomModal";
import DynamicLoader from "../Form/FormFields/DynamicLoader";
import { RootState } from "../../utils/store/rootReducer";
import CustomTable from "../ui/CustomTable";
import { setTableChartId } from "../applicationStatus/store";
import Accordion from "../ui/Accordion";

const Successperformance = ({ ...props }: any) => {
  const propsData = props?.chartListData;
  const selector = useSelector((state: RootState) => state);
  const selectCompontData =
    selector.chartListDetails?.componentData?.ALL?.[propsData?.id];
  const dispatch = useDispatch();
  // const [typeData, setTypeData] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const fetchPopupData = async (data: any, type: any) => {
    setIsModalOpen(true);
    // setTypeData(type);
    return await ruralDetailsCount(selectCompontData?.popup_chart_id, props);
  };
  const selectorData = useSelector(
    (state: { dynamicData: DynamicData }) => state?.dynamicData
  );

  // Check if chart_value exists in props (pre-loaded data)
  const hasChartValue =
    propsData?.chart_value &&
    (propsData.chart_value.rows || propsData.chart_value.data);

  // Use chart_value from props if available, otherwise use Redux selector data
  const dynamicForThis = hasChartValue
    ? propsData.chart_value
    : selectorData?.[propsData?.id] ?? selectorData?.analysis?.[propsData?.id];

  // Only show loading when fetching from API (no chart_value in props)
  const isLoading =
    !hasChartValue && selectorData.loaders?.[`report/chart/${[propsData?.id]}`];

  const rawData: any[] = Array.isArray(dynamicForThis)
    ? dynamicForThis
    : Array.isArray(dynamicForThis?.rows)
    ? dynamicForThis.rows
    : Array.isArray(dynamicForThis?.data)
    ? dynamicForThis.data
    : [];

  const { ruralDetailsCount } = CustomHookForRuralDetails();

  useEffect(() => {
    // Only fetch data if chart_value is not present in props
    if (!hasChartValue) {
      const mapData = async () => {
        await ruralDetailsCount(propsData?.id, props);
      };
      mapData();
    }
  }, [propsData?.id, hasChartValue]);

  return (
    <>
      <div
        className={`bg-white  rounded-lg  grid gap-2 p-6 ${
          props.width && props.width
        }`}
      >
        {isLoading ? (
          <DynamicLoader loading={isLoading} />
        ) : (
          <>
            <div className="flex justify-between items-center mb-5">
              <h2 className="text-gray-800 font-semibold text-base">
                {props.chartListData.title}
              </h2>
            </div>
            <div className="flex justify-between p-1 mx-2">
              <h2 className="text-cyan-600">District</h2>
              <h2 className="text-cyan-600">No. Of Application</h2>
            </div>
            <ul className="space-y-3 mt-3 mb-3 overflow-auto  h-[240px]">
              {rawData.length > 0 &&
                rawData.map((item: any, index: number) => (
                  <li
                    key={index}
                    className="flex justify-between items-center border-b border-[#E1E3EA] last:border-none pb-3"
                  >
                    <span className="text-gray-800 text-sm">
                      {item.name || item.district_name}
                    </span>
                    <span
                      className={`${
                        propsData?.color || "bg-blue-500"
                      } text-white text-sm px-3 py-1 rounded-md font-medium online-block ${
                        propsData?.has_popup ? "cursor-pointer" : ""
                      }`}
                      onClick={async () => {
                        await dispatch(setTableChartId(item?.district_code));

                        propsData?.has_popup &&
                          fetchPopupData(propsData.popup_chart_id, "district");
                      }}
                    >
                      {item.value || item.count}
                    </span>
                  </li>
                ))}
            </ul>
            {!propsData.chart_value && (
              <Accordion
                title="AI Insights"
                componentID={propsData?.id}
                chartData={propsData}
                chartValue={dynamicForThis}
              />
            )}
          </>
        )}
      </div>

      <CustomModal
        isOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        title="Transaction Details"
      >
        <div>
          {isLoading ? (
            <DynamicLoader loading={isLoading} />
          ) : (
            //selectCompontData?.popup_chart_id
            <CustomTable
              columns={
                selectorData?.[selectCompontData?.popup_chart_id]?.columns
              }
              rows={selectorData[selectCompontData?.popup_chart_id]?.rows}
              title="Transaction Details"
            />
          )}
        </div>
      </CustomModal>
    </>
  );
};

export default Successperformance;
